import '.a{display:flex;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.d2{background:var(--shades-white);}.ssr-plugin'
import '.bu{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.b6{max-width:77.5rem;}.ssr-plugin'
import '.dp{justify-content:stretch;}.ssr-plugin'
import '.dq{position:sticky;}.ssr-plugin'
import '.cv{top:0;}.ssr-plugin'
import '.dr{z-index:10;}.ssr-plugin'
import '.ds{padding-block:1rem;}.ssr-plugin'
import '.dt{height:3rem;}.ssr-plugin'
import '.ac{justify-content:space-between;}.ssr-plugin'
import '.du{flex-wrap:wrap;}.ssr-plugin'
import '.dv{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.be{margin-top:2rem;}.ssr-plugin'
import '.gl{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ae g b d2"
      >
        <div className="bu a c g b"
        >
          <div className="b6 a b dp dq cv dr"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="ds dt a ac c du"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dv a b ae be gl b6"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
